import { Faq } from "../sections/faq.js";
import { Hero } from "../sections/hero.js";
import { OrganizerPanel } from "../sections/organizer-panel.js";
import { Split } from "../sections/split.js";
import { Statement } from "../sections/statement.js";
import { Angles } from "./angles.js";
import { Control } from "./control.js";
import { Ending } from "./ending.js";
import { Launch } from "./launch.js";
import { V2Nav } from "./nav.js";
import { Numbers } from "./numbers.js";
import type { PlannerV2Content } from "./planner-content.js";
import { Teaser } from "./teaser.js";
import { Tour } from "./tour.js";

export interface PlannerV2SiteProps {
  readonly content: PlannerV2Content;
}

export function PlannerV2Site({ content }: PlannerV2SiteProps) {
  return (
    <>
      <div id="nav-root">
        <V2Nav content={content} menu={content.menu} />
      </div>
      <Hero content={content} aside={<Teaser copy={content.teaser} flow={content.flow} />} />
      <Numbers items={content.numbers} />
      <Statement copy={content.pain} tone="sunken" />
      <Tour copy={content.tour} flow={content.flow} wall={content.wall} />
      <Launch copy={content.launch} flow={content.flow} wall={content.wall} />
      <Control copy={content.control} wall={content.wall} />
      <Angles copy={content.angles} />
      <div id="painel">
        <Split
          flip
          mediaFirst
          copy={content.organizer}
          media={<OrganizerPanel content={content} />}
        />
      </div>
      <div id="faq-root">
        <Faq content={content} />
      </div>
      <Ending copy={content.ending} content={content} />
    </>
  );
}
